module.exports = __webpack_public_path__ + "static/media/website.c9b90e0e.svg";